"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultRadioFromLabels = exports.presentRadioReturn = exports.advancedMultCheckboxReturn = exports.presentMultCheckboxReturn = exports.emptySimpleFromLabels = exports.emptyFromLabels = exports.isSelected = exports.isOneOfSelected = void 0;
const Maybe_1 = require("./Maybe");
const Util_1 = require("./Util");
const isOneOfSelected = (input) => input.values.reduce((prev, curr) => prev || curr, false);
exports.isOneOfSelected = isOneOfSelected;
const isSelected = (input, value) => !!input.values[input.labels.indexOf(value)];
exports.isSelected = isSelected;
const emptyFromLabels = (labels) => ({
    labels,
    otherSelected: false,
    values: labels.map(Util_1.alwaysFalse),
});
exports.emptyFromLabels = emptyFromLabels;
const emptySimpleFromLabels = (labels) => ({
    labels,
    values: labels.map(Util_1.alwaysFalse),
});
exports.emptySimpleFromLabels = emptySimpleFromLabels;
const presentMultCheckboxReturn = (input, seperator = ', ') => {
    const values = input.labels.filter((_, i) => input.values[i]);
    if ('otherSelected' in input && input.otherSelected) {
        values.push(input.otherValue);
    }
    const returnString = values.join(seperator);
    return !!returnString ? Maybe_1.Maybe.some(returnString) : Maybe_1.Maybe.none();
};
exports.presentMultCheckboxReturn = presentMultCheckboxReturn;
const advancedMultCheckboxReturn = (input, mapFunction) => {
    const values = input.labels.filter((_, i) => input.values[i]);
    if ('otherSelected' in input && input.otherSelected) {
        values.push(input.otherValue);
    }
    return values.map(mapFunction);
};
exports.advancedMultCheckboxReturn = advancedMultCheckboxReturn;
const presentRadioReturn = (input) => input.otherValueSelected ? input.otherValue : input.labels[input.selection];
exports.presentRadioReturn = presentRadioReturn;
const defaultRadioFromLabels = (labels) => ({
    otherValueSelected: false,
    labels,
    selection: 0,
});
exports.defaultRadioFromLabels = defaultRadioFromLabels;
//# sourceMappingURL=forms.js.map